"use client";
import React, { useState } from "react";
import { motion } from "framer-motion";
import CommonImage from "@/components/common/image/CommonImage";
import Image from "next/image";
import { useDispatch, useSelector } from "react-redux";
import AuthDrawer from "@/components/common/drawer/AuthDrawer/AuthDrawer";
import { openDrawer } from "@/redux/slices/authDrawerSlice";
import { ToastContainer, toast } from "react-toastify";
import CourseService from "@/services/api/CourseService";
import { Link } from "lucide-react";
import { useRouter } from "next/navigation";
import YoutubePlayer from "@/components/common/Player/YoutubePlayer";
import dynamic from "next/dynamic";
const Modal = dynamic(() => import("antd/es/modal"), { ssr: false });

export default function CourseHeroSection({ course }) {
  const router = useRouter();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user.userInfo);
  const [paymentMethod, setPaymentMethod] = useState("Cash");
  const [paymentFor, setPaymentFor] = useState("Course Enrollment");
  const [amount, setAmount] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);




  return (
    <>
      {" "}
      <section className="course-details-hero-section section_padding">
        <div className="container">
          <div className="content">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h1 className="title">
                {course?.title}{" "}
                <span className="highlighted">{course?.highlight_title}</span>
                {/* HSC 1st Year একাডেমিক প্রোগ্রাম <span className="highlighted">(SSC'25 ব্যাচের পরীক্ষার্থীদের জন্য)</span> */}
                {/* <h1 className="title">
                  <span className="highlighted">{course?.highlight_title}</span>{" "}
                  {course?.title} */}
              </h1>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              {course?.short_description ? (
                <p
                  className="description"
                  dangerouslySetInnerHTML={{ __html: course.short_description }}
                />
              ) : null}

              {/* <p className="description"> {course?.short_description}</p> */}
            </motion.div>
          </div>
        </div>
        <AuthDrawer />
      </section>
    </>
  );
}
